<template>
  <div class="d-flex justify-content-end">
    <nav aria-label="Page navigation example">
      <ul v-if="totalPages > 1" class="pagination">
        <li class="page-item">
          <button
            class="page-link"
            @click="onClickPreviousPage"
            :disabled="isInFirstPage"
            aria-label="Previous"
          >
            <span aria-hidden="true">&laquo;</span>
          </button>
        </li>
        <li v-for="page in pages" :key="page.name" class="page-item">
          <button
            class="page-link"
            @click="onClickPage(page.name)"
            :disabled="page.isDisabled"
            :class="{ 'active-page text-white': isPageActive(page.name) }"
          >
            {{ page.name }}
          </button>
        </li>
        <li class="page-item">
          <button
            class="page-link"
            @click="onClickNextPage"
            :disabled="isInLastPage"
            aria-label="Next"
          >
            <span aria-hidden="true">&raquo;</span>
          </button>
        </li>
      </ul>
      <ul v-else></ul>
    </nav>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 2
    },
    totalPages: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    startPage() {
      if (this.currentPage === 1) {
        return 1;
      }
      if (this.currentPage === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons + 1;
      }
      if (this.currentPage === 1) {
        return this.currentPage - 0;
      }
      return this.currentPage - 1;
    },
    endPage() {
      return Math.min(
        this.startPage + this.maxVisibleButtons - 1,
        this.totalPages
      );
    },
    pages() {
      const range = [];
      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }
      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  },
  methods: {
    onClickFirstPage() {
      this.$emit('pagechanged', 1);
    },
    onClickPreviousPage() {
      this.$emit('pagechanged', this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit('pagechanged', page);
    },
    onClickNextPage() {
      this.$emit('pagechanged', this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit('pagechanged', this.totalPages);
    },
    isPageActive(page) {
      return this.currentPage === page;
    }
  }
};
</script>
<style scoped>
.active-page {
  background: #652f8f;
}
</style>
